
import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/vue";
import {defineComponent} from "vue";
import Accordion from "@/components/Accordion.vue";
import { useRouter } from "vue-router";
import { add, reload } from "ionicons/icons";
import {
  IonSelect,
  IonSelectOption
} from '@ionic/vue';

export default defineComponent({
  name: "Home",
  data() {
    return {
      filter: ["upToDate"],
      sort: "asc"
    };
  },
  components: {
    Accordion,
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonSelect,
    IonSelectOption,
  },
  setup() {
    const customPopoverOptions: any = {

    };
    return {
      router: useRouter(),
      add,
      reload,
      customPopoverOptions,
    };
  }
});
